import { action } from 'typesafe-actions';

import { KnmHeaderActionsEnum } from '../enums/KnmHeaderActionsEnum';

export const knmComplete336 = (id: number) => action(KnmHeaderActionsEnum.KNM_COMPLETE336, { id });
export const knmHeaderHandleToApproveClick = () => action(KnmHeaderActionsEnum.KNM_HEADER_HANDLE_TO_APPROVE_CLICK);
